var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('p',[_vm._v("Loading Company...")]):_vm._e(),(_vm.company)?_c('LinkEntity',{attrs:{"payload":_vm.company,"additional_data":{ resource_type: 'Company' }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }